import React from "react";
import useScrollTrigger from "@mui/material/useScrollTrigger";

const ScrollHandler = (props) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 8,
    target: props.window ? window() : undefined,
  });

  return React.cloneElement(props.children, {
    className: `${props.children.props.className || ""} ${
      trigger ? "is-scrolled" : ""
    }`.trim(),
  });
};

const ScrollToColor = (props) => {
  return <ScrollHandler {...props}>{props.children}</ScrollHandler>;
};

export default ScrollToColor;
